import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/data.service';
import { LanguageService } from 'src/app/language.service';
import { PlayerContainerType } from 'src/app/shared/common/const/common.const';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';
import { TabService } from 'src/app/shared/services/tabs/tab.service';

@Component({
  selector: 'app-generic-aha-gold-right-panel',
  templateUrl: './generic-aha-gold-right-panel.component.html',
  styleUrls: ['./generic-aha-gold-right-panel.component.scss'],
})
export class GenericAhaGoldRightPanelComponent {
  @Input() labelData: string;
  @Input() redirectFrom: string;
  label: string;

  constructor(
    private readonly dialogService: DialogService,
    private readonly navService: NavigationLibraryService,
    private readonly languageService: LanguageService,
    private readonly dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly routeHistoryService: RouteHistoryService,
    private readonly tabService: TabService
  ) {}

  ngOnInit(): void {
    if (this.redirectFrom) {
    this.label = this.languageService.getTranslatedText('go_back');
    } else {
      this.label = this.languageService.getTranslatedText(this.labelData);
    }
    this.navService.focusContainer('gold-upgrade-right', false, 0, true);
  }

  goHomeAction() {
    if (
      this.data.redirectFrom === PlayerContainerType.EPISODES ||
      this.data.redirectFrom === PlayerContainerType.RELATED_ITEMS
    ) {
      this.dataService.disablePlayerListener = true;
      this.dialogService.close();
      this.routeHistoryService.goBack();
      return;
    } else if (this.labelData === 'go_back') {
      // When coming from vertical-menu, emit event to restore focus before closing
      if (
        this.data.redirectFrom === 'vertical-menu' &&
        this.data.selectedIndex !== undefined
      ) {
        this.dataService.emitVerticalMenuEvent({
          action: 'no-action',
          data: {
            selectedIndex: this.data.selectedIndex,
            shouldFocus: true,
            isMenuActive: true,
          },
        });
      }
      this.dialogService.closeWithResult('upgrade');
    } else {
      this.dialogService.closeAll();
      // Use selectedIndex when coming from vertical-menu, otherwise use tabId
      if (
        this.data.redirectFrom === 'vertical-menu' &&
        this.data.selectedIndex !== undefined
      ) {
        this.dataService.emitVerticalMenuEvent({
          action: 'no-action',
          data: {
            selectedIndex: this.data.selectedIndex,
            shouldFocus: true,
          },
        });
      } else {
        this.dataService.emitVerticalMenuEvent({
          action: 'no-action',
          data: {
            tabId: this.tabService.currentTabId,
            shouldFocus: true,
          },
        });
      }
    }
  }
}
